import React from 'react';
import { Button } from 'antd';

type Props = {
  loading?: boolean,
  onClick?: () => any,
  className?: string,
};

export default function DownloadButtonRound(props: Props) {
  return (
    <Button
      className={`${props.className || ''} cursor-pointer`}
      icon="download"
      shape="round"
      style={{ padding: '0 8px' }}
      {...props}
    />
  );
}
